import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/newControl.svg'
import _imports_1 from '@/assets/controlClone.svg'
import _imports_2 from '@/assets/filterIcon_Disabled.svg'
import _imports_3 from '@/assets/filter.svg'
import _imports_4 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = { class: "flex flex-col flex-1 min-h-0 overflow-hidden" }
const _hoisted_3 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_4 = { class: "cardbody flex" }
const _hoisted_5 = { class: "flex gap-3" }
const _hoisted_6 = {
  ref: "menuContainer",
  class: "flex flex-row-reverse"
}
const _hoisted_7 = {
  key: 0,
  class: "card shadow-sm z-50 absolute cursor-pointer top-24 w-40"
}
const _hoisted_8 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_9 = {
  key: 0,
  src: _imports_2,
  class: "filterIcon"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_3,
  class: "filterIcon"
}
const _hoisted_11 = { class: "mt-5 table-section" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_14 = { class: "pl-4 pb-4 pr-4" }
const _hoisted_15 = { class: "w-full mt-3" }
const _hoisted_16 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_17 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_18 = { class: "flex mt-3" }
const _hoisted_19 = { class: "w-1/2" }
const _hoisted_20 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_21 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_22 = { class: "w-1/2" }
const _hoisted_23 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_24 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_25 = { class: "flex mt-3" }
const _hoisted_26 = { class: "w-1/2" }
const _hoisted_27 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_28 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_29 = { class: "w-1/2" }
const _hoisted_30 = { class: "text-sm mt-2" }
const _hoisted_31 = { class: "flex mt-3" }
const _hoisted_32 = { class: "w-1/2" }
const _hoisted_33 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_34 = { class: "flex mt-3" }
const _hoisted_35 = { class: "w-1/2" }
const _hoisted_36 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_37 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_38 = { class: "w-1/2" }
const _hoisted_39 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_40 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_41 = { class: "w-full mt-3" }
const _hoisted_42 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_43 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_44 = { class: "w-full mt-3" }
const _hoisted_45 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_46 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_47 = { class: "w-full mt-3" }
const _hoisted_48 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_49 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_50 = { class: "w-full mt-3" }
const _hoisted_51 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_52 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_53 = { class: "w-full mt-3" }
const _hoisted_54 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_55 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_56 = { class: "w-full mt-3" }
const _hoisted_57 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_58 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_59 = { class: "w-full mt-3" }
const _hoisted_60 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_61 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_62 = { class: "flex items-center justify-between py-4 pl-2 pr-4 rounded" }
const _hoisted_63 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_64 = {
  key: 1,
  class: "pl-2"
}
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { class: "flex flex-col h-full" }
const _hoisted_68 = { class: "flex-1 overflow-auto" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_71 = { class: "formcontainer flex flex-col" }
const _hoisted_72 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_73 = { class: "w-full mt-3" }
const _hoisted_74 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_75 = {
  key: 0,
  class: "error-text"
}
const _hoisted_76 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_77 = { class: "flex flex-row w-full mt-3" }
const _hoisted_78 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_79 = {
  key: 0,
  class: "error-text"
}
const _hoisted_80 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_81 = {
  key: 0,
  class: "error-text"
}
const _hoisted_82 = { class: "flex flex-row w-full mt-3" }
const _hoisted_83 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_84 = {
  key: 0,
  class: "error-text"
}
const _hoisted_85 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_86 = {
  key: 0,
  class: "error-text"
}
const _hoisted_87 = { class: "flex flex-row w-full mt-3" }
const _hoisted_88 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_89 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_90 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_91 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_92 = { class: "formcontainer flex flex-col mt-3" }
const _hoisted_93 = { class: "row flex flex-row w-full" }
const _hoisted_94 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_95 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_96 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_97 = { key: 1 }
const _hoisted_98 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_99 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_100 = { class: "w-6/12" }
const _hoisted_101 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_102 = {
  key: 0,
  class: "error-text"
}
const _hoisted_103 = { class: "w-full" }
const _hoisted_104 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_105 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_106 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_107 = { class: "w-full" }
const _hoisted_108 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_109 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_110 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_111 = { class: "w-full" }
const _hoisted_112 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_113 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_114 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_115 = { class: "w-full" }
const _hoisted_116 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_117 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_118 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_119 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_120 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_121 = { key: 1 }
const _hoisted_122 = { key: 0 }
const _hoisted_123 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_124 = ["disabled"]
const _hoisted_125 = ["disabled"]
const _hoisted_126 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_127 = { class: "flex flex-col h-full" }
const _hoisted_128 = { class: "flex-1 overflow-auto" }
const _hoisted_129 = { class: "flex flex-col h-full" }
const _hoisted_130 = { class: "flex-1 overflow-auto" }
const _hoisted_131 = ["disabled"]
const _hoisted_132 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_133 = { class: "formcontainer flex flex-col" }
const _hoisted_134 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_135 = { class: "w-full mt-3" }
const _hoisted_136 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_137 = {
  key: 0,
  class: "error-text"
}
const _hoisted_138 = {
  key: 1,
  class: "row flex flex-row w-full"
}
const _hoisted_139 = { class: "w-full mt-3" }
const _hoisted_140 = ["disabled"]
const _hoisted_141 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_142 = {
  key: 0,
  class: "error-text"
}
const _hoisted_143 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_144 = { class: "flex flex-row w-full mt-3" }
const _hoisted_145 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_146 = {
  key: 0,
  class: "error-text"
}
const _hoisted_147 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_148 = {
  key: 0,
  class: "error-text"
}
const _hoisted_149 = { class: "flex flex-row w-full mt-3" }
const _hoisted_150 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_151 = {
  key: 0,
  class: "error-text"
}
const _hoisted_152 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_153 = {
  key: 0,
  class: "error-text"
}
const _hoisted_154 = { class: "flex flex-row w-full mt-3" }
const _hoisted_155 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_156 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_157 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_158 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_159 = { class: "formcontainer flex flex-col mt-3" }
const _hoisted_160 = { class: "row flex flex-row w-full" }
const _hoisted_161 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_162 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_163 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_164 = { key: 1 }
const _hoisted_165 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_166 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_167 = { class: "w-6/12" }
const _hoisted_168 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_169 = {
  key: 0,
  class: "error-text"
}
const _hoisted_170 = { class: "w-full" }
const _hoisted_171 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_172 = ["disabled"]
const _hoisted_173 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_174 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_175 = { class: "w-full" }
const _hoisted_176 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_177 = ["disabled"]
const _hoisted_178 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_179 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_180 = { class: "w-full" }
const _hoisted_181 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_182 = ["disabled"]
const _hoisted_183 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_184 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_185 = { class: "w-full" }
const _hoisted_186 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_187 = ["disabled"]
const _hoisted_188 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_189 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_190 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_191 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_192 = { key: 1 }
const _hoisted_193 = { key: 0 }
const _hoisted_194 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_195 = ["disabled"]
const _hoisted_196 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_popup = _resolveComponent("popup")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[66] || (_cache[66] = _createElementVNode("h1", { class: "title" }, "Controls", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
                class: _normalizeClass(["btns flex justify-center items-center", _ctx.isAddDisabled ? 'btndisabled pointer-events-none':'btnprimary'])
              }, "Add", 2),
              (_ctx.isMenuVisible)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                    _createElementVNode("li", {
                      class: "px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.customPopupPopup && _ctx.customPopupPopup(...args)))
                    }, _cache[63] || (_cache[63] = [
                      _createElementVNode("div", { class: "flex" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "",
                          class: "mr-2"
                        }),
                        _createTextVNode("New Control")
                      ], -1)
                    ])),
                    _createElementVNode("li", {
                      class: "px-4 py-2 cursor-pointer h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showpopupOnAddCloneControl && _ctx.showpopupOnAddCloneControl(...args)))
                    }, _cache[64] || (_cache[64] = [
                      _createElementVNode("div", { class: "flex" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "",
                          class: "mr-2"
                        }),
                        _createTextVNode(" Clone Control")
                      ], -1)
                    ]))
                  ]))
                : _createCommentVNode("", true)
            ], 512),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
              }, [
                (_ctx.tableRow.length == 0)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                  : (_openBlock(), _createElementBlock("img", _hoisted_10)),
                _cache[65] || (_cache[65] = _createTextVNode(" Filters "))
              ], 2)
            ])
          ])
        ])
      ]),
      _cache[122] || (_cache[122] = _createElementVNode("div", { class: "text-xs mt-3" }, " Define, organize, and manage security controls across the organization. Map controls to systems, processes, and projects. Manage Key Performance Indicators (KPI) for the controls adopted or activated, ensuring consistent implementation, monitoring, and compliance with internal policies and external compliance frameworks. ", -1)),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_tableData, {
          class: "flex-1 min-h-0",
          tableRowData: _ctx.tableRow,
          headersData: _ctx.headers,
          loadData: _ctx.dataLoading
        }, null, 8, ["tableRowData", "headersData", "loadData"]),
        (_ctx.toolTipActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showModal)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 0,
            popUp: _ctx.showModal
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _cache[68] || (_cache[68] = _createElementVNode("h1", { class: "pl-2" }, "Active Control", -1)),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCancelbtn('close')))
                }, _cache[67] || (_cache[67] = [
                  _createElementVNode("img", {
                    src: _imports_4,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[69] || (_cache[69] = _createElementVNode("div", { class: "controllabel" }, "Control Title", -1)),
                      (_ctx.controlObject.controlTitle != undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.controlObject.controlTitle), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[70] || (_cache[70] = _createElementVNode("div", { class: "controllabel" }, "CCID", -1)),
                        (_ctx.controlObject.clientUniqueId != undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.controlObject.clientUniqueId), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[71] || (_cache[71] = _createElementVNode("div", { class: "controllabel" }, "Control Frequency", -1)),
                        (_ctx.controlObject.controlFrequency != undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.getControlFrequency(_ctx.controlObject.controlFrequency)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_24, "N/A"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _cache[72] || (_cache[72] = _createElementVNode("div", { class: "controllabel" }, "Control Class", -1)),
                        (_ctx.controlObject.controlClass != undefined && _ctx.controlObject.controlClass != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.controlObject.controlClass), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_28, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[73] || (_cache[73] = _createElementVNode("div", { class: "controllabel" }, "Owner", -1)),
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.getControlOwnerName(_ctx.controlObject.controlOwner)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _cache[74] || (_cache[74] = _createElementVNode("div", { class: "controllabel" }, "Priority", -1)),
                        (_ctx.controlObject.controlPriority && typeof _ctx.controlObject.controlPriority === 'number')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorLabelBg(_ctx.controlObject.controlPriority)])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.controlObject.controlPriority)])
                              }, _toDisplayString(_ctx.getProirityLabel(_ctx.controlObject.controlPriority)), 3)
                            ], 2))
                          : (_openBlock(), _createElementBlock("div", _hoisted_33, "N/A"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _cache[75] || (_cache[75] = _createElementVNode("div", { class: "controllabel" }, "Control Family", -1)),
                        (_ctx.controlObject.controlFamily != undefined && _ctx.controlObject.controlFamily != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.controlObject.controlFamily), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_37, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _cache[76] || (_cache[76] = _createElementVNode("div", { class: "controllabel" }, "Control Type", -1)),
                        (_ctx.controlObject.controlType != undefined && _ctx.controlObject.controlType != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.controlObject.controlType), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_40, "N/A"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _cache[77] || (_cache[77] = _createElementVNode("div", { class: "controllabel" }, "Control Guidance", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlGuidance') && (_ctx.controlObject.controlGuidance != undefined && _ctx.controlObject.controlGuidance != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.controlObject.controlGuidance), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_43, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _cache[78] || (_cache[78] = _createElementVNode("div", { class: "controllabel" }, "Audit Methodology", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlAuditMethodology') && (_ctx.controlObject.controlAuditMethodology != undefined && _ctx.controlObject.controlAuditMethodology != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.controlObject.controlAuditMethodology), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_46, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _cache[79] || (_cache[79] = _createElementVNode("div", { class: "controllabel" }, "Audit Success Criteria", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlAuditSuccessCriteria') && (_ctx.controlObject.controlAuditSuccessCriteria != undefined && _ctx.controlObject.controlAuditSuccessCriteria != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.controlObject.controlAuditSuccessCriteria), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_49, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _cache[80] || (_cache[80] = _createElementVNode("div", { class: "controllabel" }, "Policies", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlPolicies') && (_ctx.controlObject.controlPolicies != undefined && _ctx.controlObject.controlPolicies != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.controlObject.controlPolicies), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_52, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _cache[81] || (_cache[81] = _createElementVNode("div", { class: "controllabel" }, "Maintenance Task", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlMaintenanceTask') && (_ctx.controlObject.controlMaintenanceTask != undefined && _ctx.controlObject.controlMaintenanceTask != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.controlObject.controlMaintenanceTask), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_55, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _cache[82] || (_cache[82] = _createElementVNode("div", { class: "controllabel" }, "FrameWork", -1)),
                      (Object.keys(_ctx.controlObject).includes('controlOptionFrameWork') && (_ctx.controlObject.controlOptionFrameWork != undefined && _ctx.controlObject.controlOptionFrameWork != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.controlObject.controlOptionFrameWork), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_58, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _cache[83] || (_cache[83] = _createElementVNode("div", { class: "controllabel" }, "Controls", -1)),
                      (Object.keys(_ctx.controlObject).includes('frameworkControls') && (_ctx.controlObject.frameworkControls != undefined && _ctx.controlObject.frameworkControls != ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.controlObject.frameworkControls), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_61, "N/A"))
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true),
      (_ctx.customPopup)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 1,
            popUp: _ctx.customPopup
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_62, [
                (_ctx.customControlObject != undefined && _ctx.customControlObject.classificationType == 3 )
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_63, _toDisplayString(_ctx.customControlObject.controlTitle), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      (_ctx.addpopup==false)
                        ? (_openBlock(), _createElementBlock("h1", _hoisted_65, _toDisplayString(_ctx.customControlObject.controlTitle || 'N/A'), 1))
                        : (_openBlock(), _createElementBlock("h1", _hoisted_66, "Control"))
                    ])),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onCancelbtnCustom('close')))
                }, _cache[84] || (_cache[84] = [
                  _createElementVNode("img", {
                    src: _imports_4,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("fieldset", {
                    disabled: _ctx.customControlObject._id
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          (_ctx.addpopup==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                _createElementVNode("div", _hoisted_73, [
                                  _cache[85] || (_cache[85] = _createElementVNode("label", { class: "controllabel" }, "Title", -1)),
                                  _withDirectives(_createElementVNode("textarea", {
                                    type: "text-area",
                                    class: _normalizeClass(["inputboxstyling mt-2", {
                                              'is-invalid': _ctx.v$.customControlObject.controlTitle.$error
                                          }]),
                                    placeholder: "Title",
                                    onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.customControlObject.controlTitle.$touch())),
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customControlObject.controlTitle) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.customControlObject.controlTitle,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.customControlObject.controlTitle.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                        (_ctx.v$.customControlObject.controlTitle.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_75, "Required"))
                                          : (_ctx.v$.customControlObject.controlTitle && _ctx.v$.customControlObject.controlTitle.restrictCharacters100.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, "Charcter Limit is exceeded"))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[86] || (_cache[86] = _createElementVNode("label", { class: "controllabel text-xs" }, "Tier", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.customControlObject.categoryType,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.customControlObject.categoryType) = $event)),
                                options: _ctx.tierTypes,
                                optionLabel: "value",
                                optionValue: "id",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                        'is-invalid': _ctx.v$.customControlObject.categoryType.$error,
                                        'inputboxstylingForSelectAtPopup': _ctx.customControlObject.categoryType === '',
                                    }]),
                                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getTierNamesList(_ctx.customControlObject.categoryType)))
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.customControlObject.categoryType.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                    (_ctx.v$.customControlObject.categoryType.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[87] || (_cache[87] = _createElementVNode("label", { class: "controllabel text-xs" }, "Scope", -1)),
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.customControlObject.tierTitle,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.customControlObject.tierTitle) = $event)),
                                suggestions: _ctx.categoryList,
                                onComplete: _cache[11] || (_cache[11] = ($event: any) => (_ctx.asyncFindForTierTitle($event, _ctx.customControlObject.categoryType))),
                                optionLabel: "label",
                                optionValue: "value",
                                forceSelection: true,
                                disabled: _ctx.customControlObject.categoryType=='',
                                placeholder: "Type to search",
                                class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2", { 'p-invalid': _ctx.v$.customControlObject.tierTitle.$error }])
                              }, null, 8, ["modelValue", "suggestions", "disabled", "class"]),
                              (_ctx.v$.customControlObject.tierTitle.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                    (_ctx.v$.customControlObject.tierTitle.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[88] || (_cache[88] = _createElementVNode("label", { class: "controllabel text-xs" }, "Frequency", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.customControlObject.controlFrequency,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customControlObject.controlFrequency) = $event)),
                                options: _ctx.dbFrequency,
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                        'is-invalid': _ctx.v$.customControlObject.controlFrequency.$error,
                                        'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlFrequency === '',
                                    }])
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.customControlObject.controlFrequency.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                    (_ctx.v$.customControlObject.controlFrequency.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[89] || (_cache[89] = _createElementVNode("label", { class: "controllabel text-xs" }, "Priority", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.customControlObject.controlPriority,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customControlObject.controlPriority) = $event)),
                                options: _ctx.dbPriority,
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                'is-invalid': _ctx.v$.customControlObject.controlPriority.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlPriority === '',
                                            }])
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.customControlObject.controlPriority.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                    (_ctx.v$.customControlObject.controlPriority.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[90] || (_cache[90] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(_ctx.customControlObject.controlNumber || 'N/A'), 1))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "inputboxstyling mt-2 disiableState",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.customControlObject.controlNumber) = $event)),
                                onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.customControlObject.controlNumber.$touch())),
                                placeholder: "Number",
                                disabled: ""
                              }, null, 544), [
                                [
                                  _vModelText,
                                  _ctx.customControlObject.controlNumber,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.addpopup}])
                            }, [
                              _createElementVNode("div", null, [
                                _cache[91] || (_cache[91] = _createElementVNode("label", { class: "controllabel" }, "Category", -1)),
                                _createElementVNode("div", null, [
                                  (_ctx.addpopup==false)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(_ctx.customControlObject.controlType || 'N/A'), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.customControlObject.controlType,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.customControlObject.controlType) = $event)),
                                      suggestions: _ctx.filteredControlTypeOptions,
                                      onComplete: _ctx.asyncFindControlType,
                                      field: "label",
                                      forceSelection: true,
                                      placeholder: "Category",
                                      class: "p-inputtext-sm systemsstyling mt-2"
                                    }, null, 8, ["modelValue", "suggestions", "onComplete"])
                                  ]),
                                  (_ctx.v$.customControlObject.controlType.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                        (_ctx.v$.customControlObject.controlType && _ctx.v$.customControlObject.controlType.restrictCharacters300.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_91, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                              }, [
                                _cache[92] || (_cache[92] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.customControlObject.controlFamily,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.customControlObject.controlFamily) = $event)),
                                    suggestions: _ctx.filteredControlFamilyOptions,
                                    onComplete: _ctx.asyncFindControlFamily,
                                    field: "label",
                                    forceSelection: true,
                                    placeholder: "Control Family",
                                    class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2", { 'p-invalid': _ctx.v$.customControlObject.controlFamily.$error }])
                                  }, null, 8, ["modelValue", "suggestions", "onComplete", "class"])
                                ]),
                                (_ctx.v$.customControlObject.controlFamily.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                      (_ctx.v$.customControlObject.controlFamily.restrictCharacters300.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-3/6 leftspacing", {'topspace': _ctx.addpopup}])
                              }, [
                                _cache[93] || (_cache[93] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                                (_ctx.addpopup==false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(_ctx.customControlObject.controlClass || 'N/A'), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                      _createVNode(_component_AutoComplete, {
                                        modelValue: _ctx.customControlObject.controlClass,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.customControlObject.controlClass) = $event)),
                                        suggestions: _ctx.filteredControlClassOptions,
                                        onComplete: _ctx.asyncFindControlClass,
                                        field: "label",
                                        forceSelection: true,
                                        placeholder: "Control Class",
                                        class: "p-inputtext-sm systemsstyling mt-2"
                                      }, null, 8, ["modelValue", "suggestions", "onComplete"])
                                    ])),
                                (_ctx.v$.customControlObject.controlClass.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                      (_ctx.v$.customControlObject.controlClass && _ctx.v$.customControlObject.controlClass.restrictCharacters300.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_99, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.addpopup}])
                          }, [
                            _createElementVNode("div", _hoisted_100, [
                              _cache[94] || (_cache[94] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.controlOwnerSelection,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.controlOwnerSelection) = $event)),
                                suggestions: _ctx.filteredControlOwnerOptions,
                                onComplete: _ctx.asyncFindControlOwner,
                                onItemSelect: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onControlOwnerPicked($event, _ctx.customControlObject))),
                                optionLabel: "label",
                                field: "label",
                                forceSelection: true,
                                invalid: _ctx.v$.customControlObject.controlOwner.$error,
                                placeholder: "Please select one",
                                class: "p-inputtext-sm systemsstyling mt-2 w-full"
                              }, null, 8, ["modelValue", "suggestions", "onComplete", "invalid"]),
                              (_ctx.v$.customControlObject.controlOwner.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                    (_ctx.v$.customControlObject.controlOwner.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_102, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.addpopup}])
                          }, [
                            _createElementVNode("div", _hoisted_103, [
                              _cache[95] || (_cache[95] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(_ctx.customControlObject.controlDescription || 'N/A'), 1))
                                : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 1,
                                    type: "text-area",
                                    class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlDescription.$error
                                        }]),
                                    placeholder: "Description",
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.customControlObject.controlDescription) = $event)),
                                    onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.v$.customControlObject.controlDescription.$touch()))
                                  }, "                                          ", 34)), [
                                    [
                                      _vModelText,
                                      _ctx.customControlObject.controlDescription,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                              (_ctx.v$.customControlObject.controlDescription.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                    (_ctx.v$.customControlObject.controlDescription && _ctx.v$.customControlObject.controlDescription.restrictCharacters1000.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_106, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.addpopup}])
                          }, [
                            _createElementVNode("div", _hoisted_107, [
                              _cache[96] || (_cache[96] = _createElementVNode("label", { class: "controllabel" }, "Tasks", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_108, _toDisplayString(_ctx.customControlObject.controlMaintenanceTask || 'N/A'), 1))
                                : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 1,
                                    type: "text-area",
                                    class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                                  'is-invalid': _ctx.v$.customControlObject.controlMaintenanceTask.$error
                                              }]),
                                    placeholder: "Tasks",
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.customControlObject.controlMaintenanceTask) = $event)),
                                    onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.v$.customControlObject.controlMaintenanceTask.$touch()))
                                  }, "                                          ", 34)), [
                                    [
                                      _vModelText,
                                      _ctx.customControlObject.controlMaintenanceTask,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                              (_ctx.v$.customControlObject.controlMaintenanceTask.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                    (_ctx.v$.customControlObject.controlMaintenanceTask && _ctx.v$.customControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_110, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.addpopup}])
                          }, [
                            _createElementVNode("div", _hoisted_111, [
                              _cache[97] || (_cache[97] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_112, _toDisplayString(_ctx.customControlObject.controlPolicies || 'N/A'), 1))
                                : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 1,
                                    type: "text-area",
                                    class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlPolicies.$error
                                        }]),
                                    placeholder: "Policies",
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.customControlObject.controlPolicies) = $event)),
                                    onInput: _cache[26] || (_cache[26] = ($event: any) => (_ctx.v$.customControlObject.controlPolicies.$touch()))
                                  }, "                                          ", 34)), [
                                    [
                                      _vModelText,
                                      _ctx.customControlObject.controlPolicies,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                              (_ctx.v$.customControlObject.controlPolicies.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                    (_ctx.v$.customControlObject.controlPolicies && _ctx.v$.customControlObject.controlPolicies.restrictCharacters1000.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_114, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.addpopup}])
                          }, [
                            _createElementVNode("div", _hoisted_115, [
                              _cache[98] || (_cache[98] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_116, _toDisplayString(_ctx.customControlObject.controlGuidance || 'N/A'), 1))
                                : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 1,
                                    type: "text-area",
                                    class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlGuidance.$error
                                        }]),
                                    placeholder: "Guidance",
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.customControlObject.controlGuidance) = $event)),
                                    onInput: _cache[28] || (_cache[28] = ($event: any) => (_ctx.v$.customControlObject.controlGuidance.$touch()))
                                  }, "                                          ", 34)), [
                                    [
                                      _vModelText,
                                      _ctx.customControlObject.controlGuidance,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                              (_ctx.v$.customControlObject.controlGuidance.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                    (_ctx.v$.customControlObject.controlGuidance && _ctx.v$.customControlObject.controlGuidance.restrictCharacters1000.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-full col-md-6 mt-3", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[99] || (_cache[99] = _createElementVNode("label", { class: "controllabel" }, "Frameworks", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_119, _toDisplayString(_ctx.customControlObject.frameworks[0].name || 'N/A'), 1))
                              : (_openBlock(), _createBlock(_component_Select, {
                                  key: 1,
                                  modelValue: _ctx.customControlObject.controlOptionFrameWork,
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.customControlObject.controlOptionFrameWork) = $event)),
                                  options: _ctx.frameWorksList,
                                  onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.getFrameworkControls(_ctx.customControlObject.controlOptionFrameWork))),
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                              'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork === '',
                                              'stylingForInputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork !== ''
                                          }])
                                }, null, 8, ["modelValue", "options", "class"]))
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-full col-md-6 mt-3", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[100] || (_cache[100] = _createElementVNode("label", { class: "controllabel" }, "Controls", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_120, _toDisplayString(_ctx.customControlObject.frameworkControls || 'N/A'), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.customControlObject.frameworkControls,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.customControlObject.frameworkControls) = $event)),
                                    options: _ctx.frameworkControls,
                                    disabled: _ctx.customControlObject.controlOptionFrameWork=='',
                                    appendTo: "self",
                                    optionLabel: "label",
                                    optionValue: "id",
                                    placeholder: "Please select one",
                                    class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                              'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork === '',
                                                              'stylingForInputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork !== ''
                                                          }])
                                  }, null, 8, ["modelValue", "options", "disabled", "class"])
                                ]))
                          ], 2)
                        ])
                      ])
                    ])
                  ], 8, _hoisted_69)
                ]),
                (_ctx.customPopup=true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                      _cache[101] || (_cache[101] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                      _createElementVNode("div", _hoisted_123, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          disabled: _ctx.clickOnButton,
                          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onCancelbtnCustom('cancel')))
                        }, "Reset", 10, _hoisted_124),
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          disabled: _ctx.clickOnButton,
                          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.saveCustomControl(_ctx.customControlObject)))
                        }, "Save", 10, _hoisted_125)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true),
      (_ctx.showPopUpForCloneControl)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 2,
            popUp: _ctx.showPopUpForCloneControl
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_126, [
                _cache[103] || (_cache[103] = _createElementVNode("h1", { class: "pl-2" }, "Clone Control", -1)),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onCancelClonebtn()))
                }, _cache[102] || (_cache[102] = [
                  _createElementVNode("img", {
                    src: _imports_4,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("fieldset", {
                          disabled: _ctx.cloneControlObject._id
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_132, [
                              _createElementVNode("div", _hoisted_133, [
                                (_ctx.controlAddpopup==true)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                      _createElementVNode("div", _hoisted_135, [
                                        _cache[104] || (_cache[104] = _createElementVNode("label", { class: "controllabel" }, "Source Control", -1)),
                                        _createVNode(_component_AutoComplete, {
                                          modelValue: _ctx.cloneControlObject.source,
                                          "onUpdate:modelValue": [
                                            _cache[35] || (_cache[35] = ($event: any) => ((_ctx.cloneControlObject.source) = $event)),
                                            _ctx.checkTitleCleared
                                          ],
                                          suggestions: _ctx.internalControlOptions,
                                          onComplete: _ctx.asyncFindInternalControl,
                                          onItemSelect: _ctx.onSelectControlTitle,
                                          onClear: _ctx.resetCloneControlFields,
                                          optionLabel: "label",
                                          optionValue: "value",
                                          field: "label",
                                          panelClass: "clone-popup-panel",
                                          forceSelection: true,
                                          placeholder: "Source",
                                          class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", { 'p-invalid': _ctx.v$.cloneControlObject.source.$error }])
                                        }, null, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "onClear", "onUpdate:modelValue", "class"]),
                                        (_ctx.v$.cloneControlObject.source.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                              (_ctx.v$.cloneControlObject.source.required.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_137, "Required"))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.controlAddpopup==true)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                      _createElementVNode("div", _hoisted_139, [
                                        _cache[105] || (_cache[105] = _createElementVNode("label", { class: "controllabel" }, "Control Title", -1)),
                                        _withDirectives(_createElementVNode("textarea", {
                                          type: "text-area",
                                          class: _normalizeClass(["inputboxstyling mt-2", {
                                              'is-invalid': _ctx.v$.cloneControlObject.controlTitle.$error,
                                              'disabled-textarea': !_ctx.cloneControlObject.source
                                          }]),
                                          placeholder: "Control Title",
                                          disabled: !_ctx.cloneControlObject.source,
                                          onInput: _cache[36] || (_cache[36] = ($event: any) => (_ctx.v$.cloneControlObject.controlTitle.$touch())),
                                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.cloneControlObject.controlTitle) = $event))
                                        }, null, 42, _hoisted_140), [
                                          [
                                            _vModelText,
                                            _ctx.cloneControlObject.controlTitle,
                                            void 0,
                                            { trim: true }
                                          ]
                                        ]),
                                        (_ctx.v$.cloneControlObject.controlTitle.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                              (_ctx.v$.cloneControlObject.controlTitle.required.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_142, "Required"))
                                                : (_ctx.v$.cloneControlObject.controlTitle && _ctx.v$.cloneControlObject.controlTitle.restrictCharacters100.$invalid)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_143, "Charcter Limit is exceeded"))
                                                  : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_144, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w-6/12", {'topspace': _ctx.controlAddpopup}])
                                  }, [
                                    _cache[106] || (_cache[106] = _createElementVNode("label", { class: "controllabel text-xs" }, "Tier", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.cloneControlObject.categoryType,
                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.cloneControlObject.categoryType) = $event)),
                                      options: _ctx.tierTypes,
                                      optionLabel: "value",
                                      optionValue: "id",
                                      placeholder: "Please select one",
                                      disabled: !_ctx.cloneControlObject.source,
                                      class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                           'is-invalid': _ctx.v$.cloneControlObject.categoryType.$error,
                                           'inputboxstylingForSelectAtPopup': _ctx.cloneControlObject.categoryType === '',
                                          }]),
                                      onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.getTierNamesList(_ctx.cloneControlObject.categoryType)))
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.cloneControlObject.categoryType.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                          (_ctx.v$.cloneControlObject.categoryType.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_146, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.controlAddpopup}])
                                  }, [
                                    _cache[107] || (_cache[107] = _createElementVNode("label", { class: "controllabel text-xs" }, "Scope", -1)),
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.cloneControlObject.tierTitle,
                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.cloneControlObject.tierTitle) = $event)),
                                      suggestions: _ctx.categoryList,
                                      onComplete: _cache[41] || (_cache[41] = ($event: any) => (_ctx.asyncFindForTierTitle($event, _ctx.cloneControlObject.categoryType))),
                                      optionLabel: "label",
                                      optionValue: "value",
                                      forceSelection: true,
                                      disabled: _ctx.cloneControlObject.categoryType==''||!_ctx.cloneControlObject.source,
                                      placeholder: "Type to search",
                                      class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2", { 'p-invalid': _ctx.v$.cloneControlObject.tierTitle.$error }])
                                    }, null, 8, ["modelValue", "suggestions", "disabled", "class"]),
                                    (_ctx.v$.cloneControlObject.tierTitle.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                          (_ctx.v$.cloneControlObject.tierTitle.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_148, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _createElementVNode("div", _hoisted_149, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w-6/12", {'topspace': _ctx.controlAddpopup}])
                                  }, [
                                    _cache[108] || (_cache[108] = _createElementVNode("label", { class: "controllabel text-xs" }, "Frequency", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.cloneControlObject.controlFrequency,
                                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.cloneControlObject.controlFrequency) = $event)),
                                      options: _ctx.dbFrequency,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      disabled: !_ctx.cloneControlObject.source,
                                      class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                        'is-invalid': _ctx.v$.cloneControlObject.controlFrequency.$error,
                                        'inputboxstylingForSelectAtPopup': _ctx.cloneControlObject.controlFrequency === '',
                                    }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.cloneControlObject.controlFrequency.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                          (_ctx.v$.cloneControlObject.controlFrequency.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_151, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.controlAddpopup}])
                                  }, [
                                    _cache[109] || (_cache[109] = _createElementVNode("label", { class: "controllabel text-xs" }, "Priority", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.cloneControlObject.controlPriority,
                                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.cloneControlObject.controlPriority) = $event)),
                                      options: _ctx.dbPriority,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                'is-invalid': _ctx.v$.cloneControlObject.controlPriority.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.cloneControlObject.controlPriority === '',
                                            }]),
                                      disabled: !_ctx.cloneControlObject.source
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.cloneControlObject.controlPriority.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                                          (_ctx.v$.cloneControlObject.controlPriority.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_153, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _createElementVNode("div", _hoisted_154, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w-6/12", {'topspace': _ctx.controlAddpopup}])
                                  }, [
                                    _cache[110] || (_cache[110] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                                    (_ctx.controlAddpopup==false)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_155, _toDisplayString(_ctx.cloneControlObject.clientUniqueId ? _ctx.cloneControlObject.clientUniqueId:_ctx.cloneControlObject.controlNumber|| 'N/A'), 1))
                                      : _createCommentVNode("", true),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "inputboxstyling mt-2 disiableState",
                                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.cloneControlObject.controlNumber) = $event)),
                                      placeholder: "Number",
                                      disabled: ""
                                    }, null, 512), [
                                      [
                                        _vModelText,
                                        _ctx.cloneControlObject.controlNumber,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ], 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.controlAddpopup}])
                                  }, [
                                    _createElementVNode("div", null, [
                                      _cache[111] || (_cache[111] = _createElementVNode("label", { class: "controllabel" }, "Category", -1)),
                                      _createElementVNode("div", null, [
                                        (_ctx.controlAddpopup==false)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_156, _toDisplayString(_ctx.cloneControlObject.controlType || 'N/A'), 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_AutoComplete, {
                                            modelValue: _ctx.cloneControlObject.controlType,
                                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.cloneControlObject.controlType) = $event)),
                                            suggestions: _ctx.filteredControlTypeOptions,
                                            onComplete: _ctx.asyncFindControlType,
                                            field: "label",
                                            disabled: !_ctx.cloneControlObject.source,
                                            forceSelection: true,
                                            placeholder: "Category",
                                            class: "p-inputtext-sm systemsstyling mt-2"
                                          }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled"])
                                        ]),
                                        (_ctx.v$.cloneControlObject.controlType.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                              (_ctx.v$.cloneControlObject.controlType && _ctx.v$.cloneControlObject.controlType.restrictCharacters300.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_158, "Charcter Limit is exceeded"))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ], 2)
                                ]),
                                _createElementVNode("div", _hoisted_159, [
                                  _createElementVNode("div", _hoisted_160, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["w-6/12", {'topspace': _ctx.controlAddpopup}])
                                    }, [
                                      _cache[112] || (_cache[112] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_AutoComplete, {
                                          modelValue: _ctx.cloneControlObject.controlFamily,
                                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.cloneControlObject.controlFamily) = $event)),
                                          suggestions: _ctx.filteredControlFamilyOptions,
                                          onComplete: _ctx.asyncFindControlFamily,
                                          field: "label",
                                          forceSelection: true,
                                          disabled: !_ctx.cloneControlObject.source,
                                          placeholder: "Control Family",
                                          class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2", { 'p-invalid': _ctx.v$.cloneControlObject.controlFamily.$error }])
                                        }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"]),
                                        (_ctx.v$.cloneControlObject.controlFamily.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                                              (_ctx.v$.cloneControlObject.controlFamily && _ctx.v$.cloneControlObject.controlFamily.restrictCharacters30.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_162, "Charcter Limit is exceeded"))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 2),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["w-3/6 leftspacing", {'topspace': _ctx.controlAddpopup}])
                                    }, [
                                      _cache[113] || (_cache[113] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                                      (_ctx.controlAddpopup==false)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_163, _toDisplayString(_ctx.cloneControlObject.controlClass || 'N/A'), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                            _createVNode(_component_AutoComplete, {
                                              modelValue: _ctx.cloneControlObject.controlClass,
                                              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.cloneControlObject.controlClass) = $event)),
                                              suggestions: _ctx.filteredControlClassOptions,
                                              onComplete: _ctx.asyncFindControlClass,
                                              field: "label",
                                              forceSelection: true,
                                              placeholder: "Control Class",
                                              disabled: !_ctx.cloneControlObject.source,
                                              class: "p-inputtext-sm systemsstyling mt-2"
                                            }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled"])
                                          ])),
                                      (_ctx.v$.cloneControlObject.controlClass.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                            (_ctx.v$.cloneControlObject.controlClass && _ctx.v$.cloneControlObject.controlClass.restrictCharacters300.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_166, "Charcter Limit is exceeded"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 2)
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.controlAddpopup}])
                                }, [
                                  _createElementVNode("div", _hoisted_167, [
                                    _cache[114] || (_cache[114] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.controlOwnerSelection,
                                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.controlOwnerSelection) = $event)),
                                      suggestions: _ctx.filteredControlOwnerOptions,
                                      onComplete: _ctx.asyncFindControlOwner,
                                      onItemSelect: _cache[49] || (_cache[49] = ($event: any) => (_ctx.onControlOwnerPicked($event, _ctx.cloneControlObject))),
                                      optionLabel: "label",
                                      field: "label",
                                      disabled: !_ctx.cloneControlObject.source,
                                      forceSelection: true,
                                      invalid: _ctx.v$.cloneControlObject.controlOwner.$error,
                                      placeholder: "Please select one",
                                      class: "p-inputtext-sm systemsstyling mt-2 w-full"
                                    }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled", "invalid"]),
                                    (_ctx.v$.cloneControlObject.controlOwner.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                                          (_ctx.v$.cloneControlObject.controlOwner.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_169, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.controlAddpopup}])
                                }, [
                                  _createElementVNode("div", _hoisted_170, [
                                    _cache[115] || (_cache[115] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                                    (_ctx.controlAddpopup==false)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_171, _toDisplayString(_ctx.cloneControlObject.controlDescription || 'N/A'), 1))
                                      : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                          key: 1,
                                          type: "text-area",
                                          class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.cloneControlObject.controlDescription.$error,
                                            'disabled-textarea': !_ctx.cloneControlObject.source
                                        }]),
                                          placeholder: "Description",
                                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.cloneControlObject.controlDescription) = $event)),
                                          disabled: !_ctx.cloneControlObject.source,
                                          onInput: _cache[51] || (_cache[51] = ($event: any) => (_ctx.v$.cloneControlObject.controlDescription.$touch()))
                                        }, "                                          ", 42, _hoisted_172)), [
                                          [
                                            _vModelText,
                                            _ctx.cloneControlObject.controlDescription,
                                            void 0,
                                            { trim: true }
                                          ]
                                        ]),
                                    (_ctx.v$.cloneControlObject.controlDescription.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                                          (_ctx.v$.cloneControlObject.controlDescription && _ctx.v$.cloneControlObject.controlDescription.restrictCharacters1000.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_174, "Charcter Limit is exceeded"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.controlAddpopup}])
                                }, [
                                  _createElementVNode("div", _hoisted_175, [
                                    _cache[116] || (_cache[116] = _createElementVNode("label", { class: "controllabel" }, "Tasks", -1)),
                                    (_ctx.controlAddpopup==false)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_176, _toDisplayString(_ctx.cloneControlObject.controlMaintenanceTask || 'N/A'), 1))
                                      : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                          key: 1,
                                          type: "text-area",
                                          class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                                  'is-invalid': _ctx.v$.cloneControlObject.controlMaintenanceTask.$error,
                                                  'disabled-textarea': !_ctx.cloneControlObject.source
                                              }]),
                                          placeholder: "Tasks",
                                          disabled: !_ctx.cloneControlObject.source,
                                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.cloneControlObject.controlMaintenanceTask) = $event)),
                                          onInput: _cache[53] || (_cache[53] = ($event: any) => (_ctx.v$.cloneControlObject.controlMaintenanceTask.$touch()))
                                        }, "                                          ", 42, _hoisted_177)), [
                                          [
                                            _vModelText,
                                            _ctx.cloneControlObject.controlMaintenanceTask,
                                            void 0,
                                            { trim: true }
                                          ]
                                        ]),
                                    (_ctx.v$.cloneControlObject.controlMaintenanceTask.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                          (_ctx.v$.cloneControlObject.controlMaintenanceTask && _ctx.v$.cloneControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_179, "Charcter Limit is exceeded"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.controlAddpopup}])
                                }, [
                                  _createElementVNode("div", _hoisted_180, [
                                    _cache[117] || (_cache[117] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                                    (_ctx.controlAddpopup==false)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_181, _toDisplayString(_ctx.cloneControlObject.controlPolicies || 'N/A'), 1))
                                      : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                          key: 1,
                                          type: "text-area",
                                          class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.cloneControlObject.controlPolicies.$error,
                                            'disabled-textarea': !_ctx.cloneControlObject.source
                                        }]),
                                          placeholder: "Policies",
                                          disabled: !_ctx.cloneControlObject.source,
                                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.cloneControlObject.controlPolicies) = $event)),
                                          onInput: _cache[55] || (_cache[55] = ($event: any) => (_ctx.v$.cloneControlObject.controlPolicies.$touch()))
                                        }, "                                          ", 42, _hoisted_182)), [
                                          [
                                            _vModelText,
                                            _ctx.cloneControlObject.controlPolicies,
                                            void 0,
                                            { trim: true }
                                          ]
                                        ]),
                                    (_ctx.v$.cloneControlObject.controlPolicies.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                                          (_ctx.v$.cloneControlObject.controlPolicies && _ctx.v$.cloneControlObject.controlPolicies.restrictCharacters1000.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_184, "Charcter Limit is exceeded"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.controlAddpopup}])
                                }, [
                                  _createElementVNode("div", _hoisted_185, [
                                    _cache[118] || (_cache[118] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                                    (_ctx.controlAddpopup==false)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_186, _toDisplayString(_ctx.cloneControlObject.controlGuidance || 'N/A'), 1))
                                      : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                          key: 1,
                                          type: "text-area",
                                          class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.cloneControlObject.controlGuidance.$error,
                                            'disabled-textarea': !_ctx.cloneControlObject.source
                                        }]),
                                          placeholder: "Guidance",
                                          disabled: !_ctx.cloneControlObject.source,
                                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.cloneControlObject.controlGuidance) = $event)),
                                          onInput: _cache[57] || (_cache[57] = ($event: any) => (_ctx.v$.cloneControlObject.controlGuidance.$touch()))
                                        }, "                                          ", 42, _hoisted_187)), [
                                          [
                                            _vModelText,
                                            _ctx.cloneControlObject.controlGuidance,
                                            void 0,
                                            { trim: true }
                                          ]
                                        ]),
                                    (_ctx.v$.cloneControlObject.controlGuidance.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                                          (_ctx.v$.cloneControlObject.controlGuidance && _ctx.v$.cloneControlObject.controlGuidance.restrictCharacters1000.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_189, "Charcter Limit is exceeded"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["w-full col-md-6 mt-3", {'topspace': _ctx.controlAddpopup}])
                                }, [
                                  _cache[119] || (_cache[119] = _createElementVNode("label", { class: "controllabel" }, "Frameworks", -1)),
                                  (_ctx.controlAddpopup==false)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_190, _toDisplayString(_ctx.cloneControlObject.frameworks[0].name || 'N/A'), 1))
                                    : (_openBlock(), _createBlock(_component_Select, {
                                        key: 1,
                                        modelValue: _ctx.cloneControlObject.controlOptionFrameWork,
                                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.cloneControlObject.controlOptionFrameWork) = $event)),
                                        options: _ctx.frameWorksList,
                                        onChange: _cache[59] || (_cache[59] = ($event: any) => (_ctx.getFrameworkControls(_ctx.cloneControlObject.controlOptionFrameWork))),
                                        placeholder: "Please select one",
                                        disabled: !_ctx.cloneControlObject.source,
                                        class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                              'inputboxstylingForSelectAtPopup': _ctx.cloneControlObject.controlOptionFrameWork === '',
                                              'stylingForInputboxstylingForSelectAtPopup': _ctx.cloneControlObject.controlOptionFrameWork !== ''
                                          }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]))
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["w-full col-md-6 mt-3", {'topspace': _ctx.controlAddpopup}])
                                }, [
                                  _cache[120] || (_cache[120] = _createElementVNode("label", { class: "controllabel" }, "Controls", -1)),
                                  (_ctx.controlAddpopup==false)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_191, _toDisplayString(_ctx.cloneControlObject.frameworkControls || 'N/A'), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_192, [
                                        _createVNode(_component_Select, {
                                          modelValue: _ctx.cloneControlObject.frameworkControls,
                                          "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.cloneControlObject.frameworkControls) = $event)),
                                          options: _ctx.frameworkControls,
                                          disabled: _ctx.cloneControlObject.controlOptionFrameWork==''||!_ctx.cloneControlObject.source,
                                          appendTo: "self",
                                          optionLabel: "label",
                                          optionValue: "id",
                                          placeholder: "Please select one",
                                          class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                              'inputboxstylingForSelectAtPopup': _ctx.cloneControlObject.controlOptionFrameWork === '',
                                                              'stylingForInputboxstylingForSelectAtPopup': _ctx.cloneControlObject.controlOptionFrameWork !== ''
                                                          }])
                                        }, null, 8, ["modelValue", "options", "disabled", "class"])
                                      ]))
                                ], 2)
                              ])
                            ])
                          ])
                        ], 8, _hoisted_131)
                      ])
                    ])
                  ])
                ]),
                (_ctx.showPopUpForCloneControl=true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                      _cache[121] || (_cache[121] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                      _createElementVNode("div", _hoisted_194, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary mr-1.5", _ctx.cloneControldisableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          disabled: _ctx.clickOnButton,
                          onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.onCanclebtnCloneCustom('cancel')))
                        }, "Reset", 10, _hoisted_195),
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary", _ctx.cloneControldisableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          disabled: _ctx.clickOnButton,
                          onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.saveCloneControl(_ctx.cloneControlObject)))
                        }, "Save", 10, _hoisted_196)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true)
    ])
  ]))
}